/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-escape */
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Header } from '../../components/Header/Header';
import { CdlMenu } from '../../components/CdlMenu/CdlMenu';
import { Input } from '../../components/Inputs/Input';
import { InputTelefoneMask } from '../../components/Inputs/InputTelefoneMask/InputTelefoneMask';
import { Telefone, useDevedor } from '../../context/ConsultContext';
import { TableInvoices } from '../../components/Table/TableInvoices/TableInvoices';
import { api } from '../../services/api';

import {
  Container,
  ConsultaContainer,
  DataContainer,
  FormContainer,
  InputBlock,
  Button,
} from './styles';
import { useInvoicesTable } from '../../context/TableContext';
import { InputTelefoneFixoMask } from '../../components/Inputs/InputTelefoneFixoMask/InputTelefoneFixoMask';
import { useLoading } from '../../hooks/useLoading';
import { Loader } from '../../components/Loader/Loader';
import { IoMdHome } from 'react-icons/io';

interface Parcela {
  valorparc: number;
  valorPago?: number;
  vencimento: string;
  pagamento: string;
  documento: number;
  nroparc: number;
}
export type IFaturas = {
  documento: number;
  tipodoc: number;
  n_inicial?: number;
  n_final?: number;
  qtdeparc: number;
  data1parc: string;
  valorparc: number;
  valorfatura?: number;
};

export interface Fatura_Parc {
  fatura: IFaturas;
  parcelas: Parcela[];
}

export const ConsultationData = () => {
  const {
    devedor,
    telefoneFixo,
    telefoneFixoComercial,
    telefoneMovel,
    telefoneMovelComercial,
    whatsapp,
    faturas_parc,
    mostrarData,
  } = useDevedor();

  const { setPageParcela, listarFaturas } = useInvoicesTable();
  const { hideLoader, showLoader, loader } = useLoading();

  const [cep, setCEP] = useState(devedor?.cep);
  const [endereco, setEndereco] = useState(devedor.endereco?.toUpperCase());
  const [bairro, setBairro] = useState(devedor?.bairro?.toUpperCase());
  const [cidade, setCidade] = useState(devedor?.cidade?.toUpperCase());
  const [uf, setUF] = useState(devedor?.uf);
  const [complemento, setComplemento] = useState(
    devedor?.complemento?.toUpperCase(),
  );
  const [numero, setNumero] = useState(devedor?.numero_endereco);
  const [email, setEmail] = useState(devedor?.email);
  const [telefoneFixoNovo, setTelefoneFixo] = useState<Telefone>(telefoneFixo);
  const [telefoneMovelNovo, setTelefoneMovel] =
    useState<Telefone>(telefoneMovel);
  const [whatsApp, setWhatsApp] = useState<Telefone>(whatsapp);
  const [empresa, setEmpresa] = useState(devedor?.empresa?.toUpperCase());
  const [telefoneFixoComer, setTelefoneFixoComer] = useState<Telefone>(
    telefoneFixoComercial,
  );
  const [telefoneMovelComer, setTelefoneMovelComer] = useState<Telefone>(
    telefoneMovelComercial,
  );

  const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  const foneFormat = /^\([0-9]{2}\)\s[0-9]{4,5}-[0-9]{4}$/;

  const [text, setText] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [foneMovelError, setFoneMovelError] = useState(false);
  const [foneFixoError, setFoneFixoError] = useState(false);
  const [foneFixoComerError, setFoneFixoComer] = useState(false);
  const [foneMovelComerError, setFoneMovelComer] = useState(false);
  const [whatsappError, setWhatsappError] = useState(false);
  const [cepError, setCepError] = useState(false);

  useEffect(() => {
    showLoader();
    setPageParcela('consulta');
  }, []);

  useEffect(() => {
    listarFaturas(faturas_parc);
    hideLoader();
  }, [faturas_parc]);

  async function findCep(cep: string) {
    if (cep.length !== 8 && cep.includes('-')) {
      setText('CEP inválido (Somente números)');
      setCepError(true);
      return;
    }

    await axios.get(`https://viacep.com.br/ws/${cep}/json`).then(({ data }) => {
      if (data.erro) {
        setText('CEP não encontrado');
        setEndereco('');
        setBairro('');
        setCidade('');
        setUF('');
        setCepError(true);
        return;
      }
      setText('');
      setEndereco(data.logradouro);
      setBairro(data.bairro);
      setCidade(data.localidade);
      setUF(data.uf);
      setCepError(false);
    });
  }

  function validaTelefone(telefone: string, nomeCampo: string) {
    if (telefone.length !== 0) {
      if (!foneFormat.test(telefone)) {
        setText(`${nomeCampo} inválido`);
        if (nomeCampo === 'Telefone Fixo') {
          setFoneFixoError(true);
        } else if (nomeCampo === 'Telefone Movel') {
          setFoneMovelError(true);
        } else if (nomeCampo === 'Telefone Fixo Comercial') {
          setFoneFixoComer(true);
        } else if (nomeCampo === 'Telefone Movel Comercial') {
          setFoneMovelComer(true);
        } else if (nomeCampo === 'Whatsapp') {
          setWhatsappError(true);
        }
      }
      return;
    }
    setText('');
    setFoneFixoComer(false);
    setFoneMovelComer(false);
    setFoneFixoError(false);
    setFoneMovelError(false);
  }

  async function validaEmail(email: string) {
    if (!mailFormat.test(email)) {
      setText('Email inválido');
      setEmailError(true);
      return;
    }
    setText('');
    setEmailError(false);
  }

  async function update(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.preventDefault();

    const novoDevedor = {
      cep,
      endereco,
      bairro,
      cidade,
      uf,
      complemento,
      numero_endereco: Number(numero),
      email,
      empresa,
    };

    const novoTelefones: Telefone[] = [
      telefoneFixoNovo,
      telefoneMovelNovo,
      whatsApp,
      telefoneFixoComer,
      telefoneMovelComer,
    ];

    showLoader();
    const response = await api.put(`devedor/update/${devedor.cpf}`, {
      devedor: novoDevedor,
      telefones: novoTelefones,
      credor: '685',
    });

    if (response.status === 200) {
      hideLoader();
      mostrarData(false);
    }
  }

  return (
    <Container>
      <Header icon={<IoMdHome color="#A6A6A6" size="32px" />} title="Devedor" />

      <ConsultaContainer>
        <CdlMenu page="devedor" />
        <DataContainer>
          <hr />
          <DataContainer>
            <FormContainer>
              <p>Dados do devedor</p>

              <form>
                <InputBlock>
                  <Input
                    name="cpf"
                    label="CPF/CNPJ"
                    size={170}
                    placeholder={devedor?.cpf}
                    readOnly={true}
                    className="readOnly"
                  />
                  <Input
                    name="name"
                    label="Nome/Razão Social"
                    size={230}
                    placeholder={devedor?.nome?.toUpperCase()}
                    readOnly={true}
                    className="readOnly"
                  />
                  <Input
                    name="cep"
                    label="CEP"
                    isError={cepError}
                    size={110}
                    value={cep}
                    onFocus={(e) => findCep(e.target.value)}
                    onChange={(e) => setCEP(e.target.value)}
                  />
                  <Input
                    name="logradouro"
                    label="Logradouro"
                    size={250}
                    value={endereco?.toUpperCase()}
                    onChange={(e) => setEndereco(e.target.value)}
                  />
                  <Input
                    name="bairro"
                    label="Bairro"
                    value={bairro?.toUpperCase()}
                    size={160}
                    onChange={(e) => setBairro(e.target.value)}
                  />
                </InputBlock>

                <InputBlock>
                  <Input
                    name="cidade"
                    label="Cidade"
                    size={210}
                    value={cidade?.toUpperCase()}
                    onChange={(e) => setCidade(e.target.value)}
                  />
                  <Input
                    name="uf"
                    label="UF"
                    size={60}
                    value={uf?.toUpperCase()}
                    onChange={(e) => setUF(e.target.value)}
                  />
                  <Input
                    name="complemento"
                    label="Complemento"
                    size={170}
                    value={complemento?.toUpperCase()}
                    onChange={(e) => setComplemento(e.target.value)}
                    required={false}
                  />
                  <Input
                    name="numero"
                    label="Nº"
                    size={80}
                    maxLength={6}
                    value={numero}
                    onChange={(e) => setNumero(Number(e.target.value))}
                    placeholder={
                      devedor?.numero_endereco
                        ? String(devedor?.numero_endereco)
                        : ''
                    }
                  />
                  <Input
                    name="email"
                    label="Email"
                    type="email"
                    size={230}
                    value={email}
                    isError={emailError}
                    onBlur={(e) => validaEmail(e.target.value)}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder={devedor?.email}
                  />
                  <InputTelefoneFixoMask
                    name="fixo"
                    label="Telefone Fixo"
                    isError={foneFixoError}
                    size={140}
                    value={telefoneFixo?.telefone}
                    onBlur={(e) =>
                      validaTelefone(e.target.value, 'Telefone Fixo')
                    }
                    onChange={(e) =>
                      setTelefoneFixo({
                        telefone: e.target.value,
                        tipo: telefoneFixo?.tipo,
                        id: telefoneFixo?.id,
                        classificacao: 'F',
                      })
                    }
                    placeholder={telefoneFixo?.telefone}
                  />
                </InputBlock>

                <InputBlock>
                  <InputTelefoneMask
                    name="movel"
                    label="Telefone Móvel"
                    isError={foneMovelError}
                    size={140}
                    value={telefoneMovel?.telefone}
                    onBlur={(e) =>
                      validaTelefone(e.target.value, 'Telefone Móvel')
                    }
                    onChange={(e) =>
                      setTelefoneMovel({
                        telefone: e.target.value,
                        tipo: telefoneMovel?.tipo,
                        id: telefoneMovel?.id,
                        classificacao: 'M',
                      })
                    }
                    placeholder={telefoneMovel?.telefone}
                  />
                  <InputTelefoneMask
                    name="whatsapp"
                    label="Whatsapp"
                    isError={whatsappError}
                    size={140}
                    value={whatsApp?.telefone}
                    onBlur={(e) => validaTelefone(e.target.value, 'Whatsapp')}
                    onChange={(e) =>
                      setWhatsApp({
                        telefone: e.target.value,
                        tipo: whatsApp?.tipo,
                        id: whatsApp?.id,
                        classificacao: 'M',
                        isWhatsapp: true,
                      })
                    }
                    placeholder={whatsapp?.telefone}
                  />
                  <Input
                    name="empresa"
                    label="Nome da Empresa"
                    size={340}
                    maxLength={50}
                    value={empresa?.toUpperCase()}
                    onChange={(e) => setEmpresa(e.target.value)}
                    placeholder={devedor?.empresa}
                  />
                  <InputTelefoneFixoMask
                    name="fixo_comercial"
                    label="Telefone Fixo (Comercial)"
                    isError={foneFixoComerError}
                    size={140}
                    value={telefoneFixoComer?.telefone}
                    onBlur={(e) =>
                      validaTelefone(e.target.value, 'Telefone Fixo Comercial')
                    }
                    onChange={(e) =>
                      setTelefoneFixoComer({
                        telefone: e.target.value,
                        tipo: telefoneFixoComer?.tipo,
                        id: telefoneFixoComer?.id,
                        classificacao: 'F',
                        isComercial: true,
                      })
                    }
                    placeholder={telefoneFixoComer?.telefone}
                  />
                  <InputTelefoneMask
                    name="movel_comercial"
                    label="Telefone Móvel (Comercial)"
                    isError={foneMovelComerError}
                    size={140}
                    value={telefoneMovelComer?.telefone}
                    onBlur={(e) =>
                      validaTelefone(e.target.value, 'Telefone Móvel Comercial')
                    }
                    onChange={(e) =>
                      setTelefoneMovelComer({
                        telefone: e.target.value,
                        tipo: telefoneMovelComer?.tipo,
                        id: telefoneMovelComer?.id,
                        classificacao: 'M',
                        isComercial: true,
                      })
                    }
                    placeholder={telefoneMovelComer?.telefone}
                  />
                </InputBlock>
                <span>{text}</span>
              </form>
            </FormContainer>

            <TableInvoices />
          </DataContainer>
        </DataContainer>

        <div>
          <Button className="save-info" onClick={(e) => update(e)}>
            Salvar informações
          </Button>
        </div>
      </ConsultaContainer>
      {loader && <Loader />}
    </Container>
  );
};
